import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { RpServiceTemplate } from "@idw-types/data/reference-data/generic";

type GetServiceTemplateRequestResponse = {
    rpServiceTemplates: Array<RpServiceTemplate>;
};

export const getServiceTemplatesRequest = async (): Promise<{ data: GetServiceTemplateRequestResponse, error: any }> => {
    const route = apiRoutes.serviceConfiguration.data.serviceTemplate;

    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};